
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-apps/network-field-service",
      function () {
        return require("private-next-pages/data-apps/network-field-service/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-apps/network-field-service"])
      });
    }
  